module.exports = __webpack_public_path__ + "img/wave.9264de64.png";